import WebModule from '../web_module'

export default class List extends WebModule

  @selector: '.modulor_web_module_list'

# do not register since this is just superclass
